import SiteLayout from "@/components/feature/SiteLayout";
import Hero from "./components/Hero";
import TrustStrip from "./components/TrustStrip";
import ServicesGrid from "./components/ServicesGrid";
import ProcessSection from "./components/ProcessSection";
import WhyUsSection from "./components/WhyUsSection";
import TestimonialsSection from "./components/TestimonialsSection";
import CTASection from "./components/CTASection";

export default function SiteHomePage() {
  return (
    <SiteLayout navVariant="transparent">
      <Hero />
      <TrustStrip />
      <ServicesGrid />
      <ProcessSection />
      <WhyUsSection />
      <TestimonialsSection />
      <CTASection />
    </SiteLayout>
  );
}